import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { createArea } from '../../graphql/facilities/create-area';
import { deleteArea } from '../../graphql/facilities/delete-area';
import { getArea } from '../../graphql/facilities/get-area';
import { getAreas } from '../../graphql/facilities/get-areas';
import { queryForAreas } from '../../graphql/facilities/query-for-areas';
import { updateArea } from '../../graphql/facilities/update-area';
import { BaseAppSyncService } from '../base-app-sync.service';
import {
  Area,
  AreaConnection,
  AreaSortOrQuery,
  CreateAreaInput,
  UpdateAreaInput,
} from 'src/app/model/locations/area';
import { AreaBuilderService } from '../builder/area-builder.service';

@Injectable({
  providedIn: 'root',
})
export class AreaApiService extends BaseAppSyncService {
  protected _areaBuilder = inject(AreaBuilderService);

  queryForAreas(
    limit: number,
    page: number,
    query: AreaSortOrQuery,
    sort: AreaSortOrQuery
  ): Observable<AreaConnection> {
    return this.query(
      queryForAreas,
      { limit, page, query, sort },
      (i: any) => this._areaBuilder.buildAreaConnection(i),
      'queryForAreas'
    );
  }

  getAreas(): Observable<Area[]> {
    return this.query(
      getAreas,
      {},
      (items: any[]) => items.map((item) => this._areaBuilder.buildArea(item)),
      'getAreas',
      'cache-first'
    );
  }

  getArea(id: string): Observable<Area> {
    return this.query(
      getArea,
      { id },
      (i: any) => this._areaBuilder.buildArea(i),
      'getArea'
    );
  }

  deleteArea(id: string): Observable<boolean> {
    return this.mutate(deleteArea, { id }, (i: any) => true, 'deleteArea');
  }

  updateArea(id: string, areaInput: UpdateAreaInput): Observable<Area> {
    return this.mutate(
      updateArea,
      { id, input: areaInput },
      (i: any) => this._areaBuilder.buildArea(i),
      'updateArea'
    );
  }

  createArea(areaInput: CreateAreaInput): Observable<Area> {
    return this.mutate(
      createArea,
      { input: areaInput },
      (i: any) => this._areaBuilder.buildArea(i),
      'createArea'
    );
  }
}
